<h4 mat-dialog-title>
    {{data.header}}
</h4>

<mat-dialog-content>
    {{data.message}}
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button" class="btn btn-primary m-1" (click)="yes()">{{data.yesText}}</button>
    <button type="button" class="btn btn-secondary m-1" (click)="no()">{{data.noText}}</button>
</mat-dialog-actions>
